import './assets/css/tailwind.output.css';

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';

import { Windmill } from '@windmill/react-ui';

import App from './App';
import ThemedSuspense from './components/ThemedSuspense';
import ThemeClassSync from './components/ThemeClassSync';
// providers
import { ScrollProvider } from './context/ScrollContext';
import { SidebarProvider } from './context/SidebarContext';
import { UserProvider } from './context/UserContext';
import { UserTagsProvider } from './context/UserTagsContext';
import * as serviceWorker from './serviceWorker';

export const createStoreProvider =
  (providers) =>
  ({ children }) =>
    providers
      .reverse()
      .reduce((tree, Provider) => <Provider>{tree}</Provider>, children);

const ProviderWrapper = createStoreProvider([
  ScrollProvider,
  UserProvider,
  SidebarProvider,
  UserTagsProvider,
]);

// if (process.env.NODE_ENV !== 'production') {
//   const axe = require('react-axe')
//   axe(React, ReactDOM, 1000)
// }

ReactDOM.render(
  <ProviderWrapper>
    <Suspense fallback={<ThemedSuspense />}>
      <Windmill usePreferences>
        <ThemeClassSync />
        <App />
      </Windmill>
    </Suspense>
  </ProviderWrapper>,
  document.getElementById('root')
);

serviceWorker.register({
  onUpdate: (registration) => {
    const waitingWorker = registration.waiting;

    if (!waitingWorker) {
      return;
    }

    const shouldUpdate = window.confirm(
      'A new Gudnest BO version is available. Reload now?'
    );

    if (!shouldUpdate) {
      return;
    }

    waitingWorker.postMessage({ type: 'SKIP_WAITING' });
    waitingWorker.addEventListener('statechange', (event) => {
      if (event.target.state === 'activated') {
        window.location.reload();
      }
    });
  },
});
